import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { LoginWriteDTO } from '../interfaces/user';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private dataService: DataService) { }

  setNewPassword(email: string, password: string, token: string) {
    return this.dataService.setNewPassword(email, password, token);
  }

  register(login: LoginWriteDTO): Observable<any> {
    return this.dataService.register(login);
  }

  validateEmail(login: LoginWriteDTO): Observable<any> {
    return this.dataService.validateEmail(login);
  }

  login(email: string, password: string, deviceId: string): Observable<any> {
    return this.dataService.login(email, password, deviceId);
  }

  resetPassword(email: string): Observable<any> {
    return this.dataService.resetPassword(email);
  }
}
